import type { ImageProps } from '@mote/ui/components'
import { H2, Image, Link, Text } from '@mote/ui/components'
import styled, { th } from '@xstyled/styled-components'
import { Container } from './shared'

type IntegrationLogo = {
  name: string
  props: Pick<ImageProps, 'src' | 'alt'>
}

type IntegrationLogos = Array<IntegrationLogo>

const LOGOS: IntegrationLogos = [
  {
    name: 'gmail',
    props: {
      src: 'https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62c57bde2430ddbe42eed054_Google%20Sheets-1.svg',
      alt: 'Gmail Logo'
    }
  },
  {
    name: 'docs',
    props: {
      src: 'https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62c57bde28328f174a3f0fb2_Frame.svg',
      alt: 'Google Docs Logo'
    }
  },
  {
    name: 'sheets',
    props: {
      src: 'https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62c57bde0ae2c632c2469662_Google%20Sheets.svg',
      alt: 'Google Sheets Logo'
    }
  },
  {
    name: 'slides',
    props: {
      src: 'https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62c57bde3f6cdd312ff00afb_Google%20Slides.svg',
      alt: 'Google Slides Logo'
    }
  },
  {
    name: 'forms',
    props: {
      src: 'https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62c57bdebc1aaa94b5f67e6d_Google%20Forms.svg',
      alt: 'Google Forms Logo'
    }
  },
  {
    name: 'classroom',
    props: {
      src: 'https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62c57bdebc1aaa7c86f67e6c_Google%20Classroom.svg',
      alt: 'Google Classroom Logo'
    }
  }
]

export const IntegrationsSection = (): JSX.Element => {
  return (
    <Root>
      <Title>Integrated into the tools you know and love</Title>
      <LogosContainer>
        {LOGOS.map(logo => (
          <Logo key={logo.name} loading='lazy' {...logo.props} />
        ))}
      </LogosContainer>
      <Rating to='https://chrome.google.com/webstore/detail/mote-voice-notes-feedback/ajphlblkfpppdpkgokiejbjfohfohhmk?hl=en-GB'>
        <Image
          src='https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/626aa0f29abe2381a2725361_Chrome_Store_Stars.svg'
          loading='lazy'
          alt='Google Chrome Store reviews'
        />
        120+ Reviews
        <RatingDivider>|</RatingDivider>
        <CountingUsers>1,000,000+ users</CountingUsers>
      </Rating>
    </Root>
  )
}

const Root = styled(Container)`
  padding-top: 80px;
  padding-bottom: 40px;

  @media (max-width: 991px) {
    padding-top: 40px;
    padding-bottom: 20px;
  }
`

const Title = styled(H2).attrs({
  alignment: 'center',
  lineHeight: '123.5%',
  fontWeight: 400,
  color: 'black'
})`
  width: 80%;
  font-size: 39px;

  @media (max-width: 991px) {
    font-size: 32px;
  }
`

const LogosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin-top: 56px;

  @media (max-width: 767px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-top: 20px;
    grid-gap: 16px;
  }

  @media (max-width: 479px) {
    width: 90%;
  }
`

const Logo = styled(Image)`
  width: 90px;
  height: 90px;
  padding: 0 16px;
  max-width: 100%;
`

const Rating = styled(Link).attrs({
  fontSize: 16,
  lineHeight: '20px',
  fontWeight: 400,
  color: 'grey.d2'
})`
  display: flex;
  margin-top: 4vh;
  gap: 8px;

  &:hover {
    color: ${th.color('grey.d2')};
  }
`

const RatingDivider = styled(Text).attrs({
  tag: 'span',
  color: 'grey.l2'
})`
  @media (max-width: 479px) {
    display: none;
  }
`

const CountingUsers = styled(Text).attrs({
  tag: 'span',
  color: 'inherit'
})`
  @media (max-width: 479px) {
    display: none;
  }
`
